import React, { useContext } from 'react';
import styled from 'styled-components';

import RelatedItem from './related-item';

import LanguageContext from '../../context/LangContext';

const Container = styled.div`
  background: #DEDEDE;
  padding: 70px 0;
`;

const Title = styled.div`
  display: flex;
  strong {
    font: italic bold 50px 'Times new roman';
    color: #6A7C40;
    margin-right: 24px;
    margin-bottom: 40px;
  }
  .border {
    border-bottom: 1px solid #999999;
    flex-grow: 1;
    height: 50px;
  }
`

const Items = styled.div`
  display: flex;
  justify-content: space-between;
  @media (max-width: 540px) {
    overflow: hidden;
  }
`;

const Related = ({items}) => {
  const { language } = useContext(LanguageContext);
  let title = ''
  switch (language) {
    case 'pt-br':
      title = 'Conteúdos Relacionados';
      break;
    case 'en-us':
      title = 'Related Content';
      break;
    case 'es-es':
      title = 'Contenido relacionado';
      break;
    default:
  }
  return (
    <Container>
      <div className="wrapper">
        <Title>
          <strong>{ title }</strong>
          <div className="border"></div>
        </Title>
        <Items>
          {
            items.map((item, index) => {
              return (
                <RelatedItem key={ index } uid={ item.uid} {...item.data} />
              )
            })
          }
        </Items>
      </div>
    </Container>
  );
}

export default Related;
